import type { Chart, ChartData, ChartOptions, Plugin } from 'chart.js';
import { type MutableRefObject, type ReactNode, type RefObject, useMemo } from 'react';
import { Line } from 'react-chartjs-2';

import { DEFAULT_LINE_CHART_OPTIONS } from '../lib/default-chart-options';
import { mergeChartConfig } from '../lib/merge-chart-config';

export type LineChartCanvasProps = {
  chartRef?: RefObject<Chart<'line'>>;
  data: ChartData<'line'>;
  options?: ChartOptions<'line'>;
  plugins?: Plugin<'line'>[];
  children?: ReactNode;
};

export const LineChartCanvas = ({
  chartRef,
  data,
  options,
  plugins,
  children,
}: LineChartCanvasProps) => {
  const mergedOptions = useMemo(
    () => mergeChartConfig(DEFAULT_LINE_CHART_OPTIONS, options),
    [options],
  );

  return (
    <>
      <Line
        ref={chartRef as MutableRefObject<Chart<'line'> | undefined | null>}
        data={data}
        options={mergedOptions}
        plugins={plugins ?? []}
      />
      {children}
    </>
  );
};
